import { UserModel } from '@steelbuy/ts-shared';

import { UserCollectionData } from './UserCollectionData';
import { useCollectionData } from '../../util/consumer/CollectionConsumerHook';

export const useUserCollectionData = () => useCollectionData<UserModel>(UserCollectionData);
